import { dateFns } from 'constants/index'
import { getPastDateInTimestamp } from 'utils/date'

const today = new Date()
const maxDate = new Date('2024-09-02')

export const PRESET_PERIODS = [
  {
    label: 'Hoje',
    period: [dateFns.startOfDay(today), dateFns.endOfDay(today)],
  },
  {
    label: 'Ontem',
    period: [new Date(getPastDateInTimestamp(1) * 1000), new Date(getPastDateInTimestamp(1, true) * 1000)],
  },
  {
    label: 'Últimos 7 dias',
    period: [new Date(getPastDateInTimestamp(7) * 1000), new Date(getPastDateInTimestamp(1, true) * 1000)],
  },
  {
    label: 'Últimos 30 dias',
    period: [new Date(getPastDateInTimestamp(30) * 1000), new Date(getPastDateInTimestamp(1, true) * 1000)],
  },
  {
    label: 'Esta semana',
    period: [dateFns.startOfWeek(today), dateFns.endOfDay(today)],
  },
  {
    label: 'Este mês',
    period: [dateFns.startOfMonth(today), dateFns.endOfDay(today)],
  },
  {
    label: 'Período máximo',
    period: [dateFns.startOfDay(maxDate), dateFns.endOfDay(today)],
  },
]
